import { createGlobalStyle } from 'styled-components';

import CustomArial from '@/assets/fonts/arial-webfont.ttf';
import Gothic from '@/assets/fonts/gothic.ttf';

const VariationsStyles = createGlobalStyle`
@font-face {
    font-family: 'CustomArial';
    src: url(${CustomArial});
  } 
   @font-face {
      font-family: 'Gothic';
      src: url(${Gothic});
    }   

  .generated-images-holder-var39 {
    position: absolute;
    bottom: 100%;
    right: 100%;
    width: 1200px;
  }
  .image-holder-var39 {
    width: 100%;
    display: flex;
    position: relative;
  }

   .right-div-var39 {
    width: 50%;
    height: 630px;
    position: relative;
    &--reversed {
      order: -1;
    }
  }

  .left-text-var39 {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 33px;
    height: 630px;
    width: 50%;
    text-align: center;
    color: #1C2327;
    font-family: Gothic;
    letter-spacing: -0.04em;
    line-height: 1.2;
    font-weight: 700;
    background-color: white;
      -webkit-text-shadow: 2.2px 0 0 #1C2327;
    -moz-text-shadow: 2.2px 0 0 #1C2327;
    -ms-text-shadow: 2.2px 0 0 #1C2327;
    -o-text-shadow: 2.2px 0 0 #1C2327;
    text-shadow: 2.2px 0 0 #1C2327;
    p {
      display: inline;
    }
  }

  .break-var39 {
    position: absolute;
    width: 12px;
    height: 100%;
    background-color: ${({ theme }) => theme.colors.white};
    left: 0;
    top: 0;
    right: 0;
    margin-left: calc(50% - 6px);
    z-index: 1;
    &--black {
      background-color: black;
    }
  }
  .right-text-var39 {
    position: absolute;
    width: 100%;
    padding: 0 10px;
    bottom: 35px;
    font-size: 45px;
    line-height: 1.2;
    text-align: center;
    color: #000;
    font-weight: 400;
    font-family: CustomArial;
    -webkit-text-shadow: 1.5px 0 0 #000;
    -moz-text-shadow: 1.5px 0 0 #000;
    -ms-text-shadow: 1.5px 0 0 #000;
    -o-text-shadow: 1.5px 0 0 #000;
    text-shadow: 1.5px 0 0 #000;
    letter-spacing: 1.2px;
    &--top {
      bottom: auto;
      top: 35px;
    }
    p {
      background-color: white;
      display: inline-block;
      margin: 0;
      padding: 14px 40px 16px;
    }
    p.custom-brakes {
      white-space: nowrap;
    }
  }

  .right-text-var39__divider {
    padding: 0 7px 0 13px;
  }

  .right-text-var39__divider-reversed {
    padding: 0 13px 0 7px;
  }

  .image-var39 {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .right-actual-photo-var39 {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 72px;
  }
  .right-actual-photo-var39--top {
    top: 0;
    bottom: auto;
  }
  .right-actual-photo-var39--reversed {
    left: 0;
    right: auto;
  }
`;

export default VariationsStyles;
